"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = require("../styled");
exports.LAYOUT_CHILDREN_CLASS_NAME = 'cosmos-layout-child';
exports.applyLayoutChildClass = function (children) {
    return React.Children.map(children, function (child) {
        if (!child) {
            return null;
        }
        return React.cloneElement(child, { className: exports.LAYOUT_CHILDREN_CLASS_NAME });
    });
};
var applyMarginReset = function (propName) {
    if (propName === void 0) { propName = 'disableMarginReset'; }
    return function (props) {
        var propValue = props[propName];
        var matchingValue = propValue !== 'undefined' ? '0' : null;
        if (matchingValue) {
            return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .cosmos-layout-child > * {\n        margin: ", ";\n      }\n\n      .cosmos-layout-child > * > *:last-child {\n        margin-bottom: ", ";\n      }\n\n      .cosmos-layout-child > * > *:first-child {\n        margin-top: ", ";\n      }\n    "], ["\n      .cosmos-layout-child > * {\n        margin: ", ";\n      }\n\n      .cosmos-layout-child > * > *:last-child {\n        margin-bottom: ", ";\n      }\n\n      .cosmos-layout-child > * > *:first-child {\n        margin-top: ", ";\n      }\n    "])), matchingValue, matchingValue, matchingValue);
        }
        return '';
    };
};
exports.default = applyMarginReset;
var templateObject_1;
//# sourceMappingURL=layout-margin-reset.js.map